import {faArrowRight, faUserTie} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Flex, Space} from 'antd';
import {ReactElement, useMemo} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {gray7} from '../../../../../../../../css/var-export.scss';
import {LangKeyType} from '../../../../../../../../provider/locale/translation/type';
import {ResponsibleUserType} from '../../../../../../../../service/reviews/reviews-responsible-users';
import {LogActionsEnum} from '../../../../../review-logs/review-log-type';

import {ResponsibleUserBadge} from './responsible-user-badge';

type PropsType = {
    action: string;
    formattedDate: string | null;
    formattedTime: string | null;
    responsibleUserName: string;
    oldValue: ResponsibleUserType | null;
    newValue: ResponsibleUserType | null;
};

export function ResponsibleUserLog(props: PropsType): ReactElement {
    const {action, formattedDate, formattedTime, responsibleUserName, oldValue, newValue} = props;

    const actionLocaleString = useMemo((): LangKeyType => {
        if (action === LogActionsEnum.Deleted) {
            return 'REVIEWS__REVIEW_LOG__RESPONSIBLE_USER__DELETED';
        }

        if (action === LogActionsEnum.Updated) {
            return 'REVIEWS__REVIEW_LOG__RESPONSIBLE_USER__UPDATED';
        }

        return 'REVIEWS__REVIEW_LOG__RESPONSIBLE_USER__CREATED';
    }, [action]);

    const targetUser = action === LogActionsEnum.Deleted ? oldValue : newValue;
    const isUpdated = action === LogActionsEnum.Updated;

    return (
        <div>
            <Text secondary>
                {formattedDate} {formattedTime}
            </Text>
            <Flex align={isUpdated ? 'flex-start' : 'center'} gap={8}>
                <FontAwesomeIcon color={gray7} fontSize={16} icon={faUserTie} />
                <Flex gap={isUpdated ? 4 : 0} vertical={isUpdated}>
                    <Space size={4} wrap>
                        <Text bolder>{responsibleUserName}</Text>
                        <Text lighter stringKey={actionLocaleString} />
                        {!isUpdated && <ResponsibleUserBadge user={targetUser} />}
                    </Space>
                    {isUpdated && (
                        <Space size={8} wrap>
                            <ResponsibleUserBadge user={oldValue} />
                            <FontAwesomeIcon color={gray7} fontSize={16} icon={faArrowRight} />
                            <ResponsibleUserBadge user={newValue} />
                        </Space>
                    )}
                </Flex>
            </Flex>
        </div>
    );
}
